<template>
    <UserForm :user="null" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Auth} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import UserForm from './UserForm.vue'

export default { 
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    UserForm
  },
 
  methods:{
    
  },
  async mounted()
  {
    
  }
}
</script>
